import { useQuery } from '@tanstack/react-query';
import { ResultHelpers } from '@treneo/models';

import { coursesApi } from '../api';
import { COURSE_TRAINER_INVITATIONS_QUERY_KEY } from '../courses-query-keys';

export { COURSE_TRAINER_INVITATIONS_QUERY_KEY } from '../courses-query-keys';

export const getCourseTrainerInvitationsQueryOptions = (courseId: string) => ({
  queryKey: [COURSE_TRAINER_INVITATIONS_QUERY_KEY, courseId] as const,
  queryFn: async () => {
    const result = await coursesApi.getCourseTrainerInvitations(courseId);
    return ResultHelpers.unwrapWith(
      result,
      data => ({ courseId, invitations: data.invitations }),
      'Get course trainer invitations failed'
    );
  }
});

type UseCourseTrainerInvitationsQueryParams = {
  courseId: string;
  enabled?: boolean;
};

export const useCourseTrainerInvitationsQuery = (
  params: UseCourseTrainerInvitationsQueryParams
) => {
  const { courseId, enabled = true } = params;

  return useQuery({
    ...getCourseTrainerInvitationsQueryOptions(courseId),
    enabled: enabled && !!courseId
  });
};
